import "./styles/app-global.css";
import { installStaleChunkReloadGuard } from "./ui/stale-chunk-reload.ts";
import { EadExpUiApp } from "./ui/app.js";

installStaleChunkReloadGuard();

// Define the custom element
if (!customElements.get("ead-expui-app")) {
  customElements.define("ead-expui-app", EadExpUiApp);
}